module.exports = __webpack_public_path__ + "static/media/card-background@2x.4e2c3917.png";